import Button from '@/common/components/Button'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import EstablishmentChoiceList from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/EstablishmentChoiceEntryFormStep/EstablishmentChoiceList'
import { useMaintenanceEstablishmentChoiceManualEntryReplaceActualProposal } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/establishmentChoice/manualEntryProposals/useMaintenanceEstablishmentChoiceManualEntryReplaceActualProposal'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

interface ManualEntriesReplaceActualProposalProps {
  manualEntryId: string
}

const ManualEntriesReplaceActualProposal = ({ manualEntryId }: ManualEntriesReplaceActualProposalProps) => {
  const { id } = useParams()

  const queryClient = useQueryClient()

  const [selectedEstablishmentId, setSelectedEstablishmentId] = useState<string | undefined>()

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const { mutate: replaceActualProposal, isPending: replaceActualProposalIsPending } =
    useMaintenanceEstablishmentChoiceManualEntryReplaceActualProposal({
      manualEntryId,
      options: {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflow', id] })
          queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflowForwardings', id] })
          queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding'] })

          setSelectedEstablishmentId(undefined)
        },
        onError: FormTransformers.errorsTransformer({ setMessages }),
      },
    })

  return (
    <>
      <div className="flex flex-col gap-4">
        <p className="text-sm">
          Defina um Estabelecimento para aceitar realizar o diagnóstico e orçamento (apenas estabelecimentos homologados
          para seu Equipamento)
        </p>

        <div className="px-4">
          <EstablishmentChoiceList
            selectedEstablishmentsIds={selectedEstablishmentId ? [selectedEstablishmentId] : []}
            onSelectEstablishment={(establishment) => {
              if (establishment.establishment_id === selectedEstablishmentId) {
                setSelectedEstablishmentId(undefined)
                return
              }

              setSelectedEstablishmentId(establishment.establishment_id)
            }}
          />
        </div>

        <div className="flex items-center justify-end">
          <Button
            operationKlassToCheckPermission="Client::Maintenance::EstablishmentChoice::ManualEntries::ReplaceActualProposal"
            disabled={!selectedEstablishmentId}
            isLoading={replaceActualProposalIsPending}
            onClick={() => {
              if (!selectedEstablishmentId) return

              replaceActualProposal({ establishment_id: selectedEstablishmentId })
            }}
          >
            Confirmar
          </Button>
        </div>
      </div>

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}

export default ManualEntriesReplaceActualProposal
